import { StyleSheet } from 'aphrodite'

const styles = StyleSheet.create({
  container: {
    background: '#fff',
    zIndex: 100,
    outline: 'none',
    borderRadius: 2,
    paddingTop: 5,
    paddingBottom: 5,
    border: '1px solid #ccc',
    position: 'fixed',
    boxShadow:
      'rgba(0, 0, 0, 0.117647) 0px 1px 6px, rgba(0, 0, 0, 0.117647) 0px 1px 4px'
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/Menu/ContextMenu/styles.js